import React from 'react';
import { FadeIn } from './FadeIn';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Sofía Martínez',
    treatment: 'Diseño de Sonrisa',
    text: 'Nunca pensé que ir al dentista podría ser una experiencia relajante. El nivel de detalle y la tecnología que usan es increíble. Mi nueva sonrisa superó todas mis expectativas.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Javier Domínguez',
    treatment: 'Implantes Dentales',
    text: 'Tenía mucho miedo al dolor, pero el Dr. Lagos me explicó todo con tanta paciencia. La cirugía fue rápida y la recuperación excelente. Volví a comer con total seguridad.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }, {
    name: 'Laura Gómez',
    treatment: 'Ortodoncia Invisible',
    text: 'Nadie nota que llevo ortodoncia. El seguimiento digital es súper cómodo y las instalaciones de la clínica parecen un hotel de lujo. 100% recomendados.',
    rating: 5,
    image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80'
  }];
  return <section id="testimonios" className="py-24 relative overflow-hidden" data-id="element-200">
      {/* Decorative blur */}
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-nova-cyan/10 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-y-1/2" data-id="element-201"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-202">
        <FadeIn className="mb-16" data-id="element-203">
          <h2 className="text-4xl md:text-5xl font-black text-nova-dark mb-6 tracking-tight" data-id="element-204">
            Lo que dicen <br data-id="element-205" />
            nuestros pacientes
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-206">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-207">
              <div className="glass-panel p-8 relative" data-id="element-208">
                <div className="flex gap-1 mb-6" data-id="element-209">
                  {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} size={18} className="fill-nova-cyan text-nova-cyan" data-id="element-210" />)}
                </div>

                <p className="text-nova-gray text-lg leading-relaxed mb-8 italic relative z-10" data-id="element-211">
                  "{testimonial.text}"
                </p>

                <div className="flex items-center gap-4" data-id="element-212">
                  <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover ring-2 ring-nova-cyan/30" data-id="element-213" />
                  <div data-id="element-214">
                    <h4 className="font-bold text-nova-dark" data-id="element-215">
                      {testimonial.name}
                    </h4>
                    <p className="text-sm text-nova-cyan" data-id="element-216">
                      {testimonial.treatment}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}